import { enumOptionsToObject } from '../../internal'

export const visibilityOptions = ['Public', 'OutfitterPage', 'WhiteLabel', 'DirectNavigation', 'Private'] as const
export const visibilities = enumOptionsToObject(visibilityOptions)
export type Visibility = (typeof visibilityOptions)[number]

export function VisibilityIsAtLeast(product: { visibility: Visibility }, visibility: Visibility): boolean {
  return visibilityOptions.indexOf(product.visibility) <= visibilityOptions.indexOf(visibility)
}
